import React from "react";
import _ from "lodash";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import ToggleLinksInput from "../../../parts/inputs/toggle-links-input";
import { useRillContext } from "../../../rill/RillReact/share/base";

const {
  PRIMARIES,
  RM_FORMULAS,
  LOAD_FORMULAS,
  LIST_FORMULAS,
  DATE_FORMATS: { DATE_DAY_FORMAT },
} = require("../../../constants");

function View(props) {
  const { t } = useTranslation("dashboard");
  const { locals } = useRillContext();

  _.defaults(locals.query, {
    type: "total",
    display: "estimated",
    units: "metric",
  });

  const { snapshot, query, momentTZ } = locals;
  const { units, display } = query;
  const hover = display === "estimated" ? "actual" : "estimated";
  const formula = _.get(snapshot, "data.formula", LIST_FORMULAS[0]);
  let exercisesRecordsLoad = _.get(snapshot, "data.exercisesRecordsLoad", {});
  exercisesRecordsLoad =
    query.type === "total"
      ? exercisesRecordsLoad
      : _.pick(exercisesRecordsLoad, [query.type]);

  return (
    <div className="Main">
      <h1 className="alt">{t("repMaxEstimator.title")}</h1>
      <p>
        {t("repMaxEstimator.description")}
      </p>

      <form id="metrics-form" action="#_" method="GET" data-noreset>
        <div className="Table-Head">
          <div className="right-side">
            <div className="group Formula-Selector">
              {t("repMaxEstimator.formula")}
              <select
                onChange={submitForm}
                name="formula"
                className="select-input"
                defaultValue={formula}
              >
                <option disabled>{t("repMaxEstimator.selectFormula")}</option>
                {_.map(LIST_FORMULAS, (type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
            <div className="group">
              <ToggleLinksInput
                name="display"
                options={[
                  { text: t("repMaxEstimator.estimated"), value: "estimated" },
                  { text: t("repMaxEstimator.actual"), value: "actual" },
                ]}
              />
            </div>
            <div className="group">
              <ToggleLinksInput
                name="units"
                options={[
                  { text: t("repMaxEstimator.kg"), value: "metric" },
                  { text: t("repMaxEstimator.lbs"), value: "imperial" },
                ]}
              />
            </div>
          </div>

          <div className="left-side">
            <div className="group">
              <ToggleLinksInput
                className="tabs"
                name="type"
                options={[
                  { text: t("repMaxEstimator.total"), value: "total" },
                  { text: t("repMaxEstimator.squat"), value: "squat" },
                  { text: t("repMaxEstimator.bench"), value: "bench" },
                  { text: t("repMaxEstimator.deadlift"), value: "deadlift" },
                ]}
              />
            </div>
          </div>
        </div>

        <div className="Table-Wrapper">
          <table className="Table">
            <thead>
              <tr>
                <th>
                  <span className="left">{t("repMaxEstimator.exercise")}</span>
                  <span className="right">{t("repMaxEstimator.reps")}</span>
                </th>
                <th>1</th>
                <th>2</th>
                <th>3</th>
                <th>4</th>
                <th>5</th>
                <th>6</th>
                <th>7</th>
                <th>8</th>
                <th>9</th>
                <th>10</th>
                <th>11</th>
                <th>12</th>
              </tr>
            </thead>
            <tbody>
              {_.flatMap(PRIMARIES, (primary) => {
                const secondaries = exercisesRecordsLoad[primary];
                return _(secondaries)
                  .map((reps, secondary) => {
                    return { reps, secondary };
                  })
                  .sortBy("secondary")
                  .map(({ reps, secondary }) => {
                    const secondaryLabel = secondary ? `(${secondary})` : "";
                    let bestRep = 0;
                    let best1RepMax = 0;

                    _.forEach(reps, ({ load }, rep) => {
                      const repMax = loadTo1RepMax(load, rep);
                      if (repMax > best1RepMax) {
                        best1RepMax = repMax;
                        bestRep = Number(rep);
                      }
                    });

                    return (
                      <tr key={primary + secondary}>
                        <td>
                          {_.capitalize(primary)} {secondaryLabel}
                        </td>
                        {_.map(_.range(1, 13), (i) => {
                          const isBest = bestRep === i;
                          const date =
                            _.has(reps[i], "date") && momentTZ(reps[i].date);
                          const loads = {
                            actual: _.get(reps[i], "load"),
                            estimated: repMaxToLoad(best1RepMax, i),
                          };
                          const displayText =
                            locals.fromMetric(loads[display], units) || "-";
                          const hoverText = `${_.capitalize(hover)}: ${
                            locals.fromMetric(loads[hover], units) || "-"
                          }`;
                          return (
                            <td key={i} className={cx({ best: isBest })}>
                              <span>
                                <span>{displayText}</span>
                                <div
                                  className="tooltip"
                                  dangerouslySetInnerHTML={{
                                    __html: hoverText,
                                  }}
                                />
                              </span>
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })
                  .value();
              })}
              <tr className="no-hover">
                <td className="personal-best" colSpan="13">
                  <b>{t("repMaxEstimator.personalBest")}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="Metrics-Foot">
          <a
            className="support text-button icon"
            href="/dashboard/support/videos?video=xEknnLP5Ns8"
          >
            <img src="/img/svg/icon_support-2.svg" alt={t("repMaxEstimator.needHelpAlt")} />
            {t("repMaxEstimator.needHelp")}
          </a>
        </div>
      </form>
    </div>
  );

  function loadTo1RepMax(load, reps) {
    if (Number(reps) === 1) return load;
    return RM_FORMULAS[formula](load, reps);
  }

  function repMaxToLoad(rm, reps) {
    return LOAD_FORMULAS[formula](rm, reps);
  }
}

function submitForm() {
  submit("#_", { body: document.getElementById("metrics-form") });
}

export default View;
